/* eslint-disable import/prefer-default-export */
import { ApolloCache } from '@apollo/client'

import { PaginatedReleaseNotesCacheObj } from '../../types'

import { PaginatedReleaseNotesQueryVariables } from '~generated/operations'
import { wrapQueryModifier } from '~lib/apollo/helpers'

export function removeReleaseNotesFromPaginatedQuery(cache: ApolloCache<any>, ids: string[]) {
  cache.modify({
    fields: {
      paginatedReleaseNotes: wrapQueryModifier<PaginatedReleaseNotesCacheObj, PaginatedReleaseNotesQueryVariables>(
        (query, { readField }) => {
          const docs = query.docs.filter((ref) => {
            return !ids.includes(readField('id', ref))
          })

          const diff = query.docs.length - docs.length
          const totalDocs = query.totalDocs - diff
          const totalPages = Math.ceil(totalDocs / query.limit)
          const page = Math.floor(docs.length / query.limit) || 1

          return {
            ...query,
            docs,
            page,
            totalPages,
            totalDocs,
          }
        }
      ),
    },
  })
}
